/**
 * Ensure the first letter of a string is upper case and return it.
 */
export const ucFirst = (text) => {
  return text.charAt(0).toUpperCase() + text.slice(1);
};